"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldErrorLabel = void 0;
const getFieldErrorLabel = (fields, fieldName) => {
    const foundField = fields.find(field => field.name === fieldName);
    return (foundField === null || foundField === void 0 ? void 0 : foundField.errorLabel) || (foundField === null || foundField === void 0 ? void 0 : foundField.label) || (foundField === null || foundField === void 0 ? void 0 : foundField.placeholder) || fieldName;
};
exports.getFieldErrorLabel = getFieldErrorLabel;
